// src/components/news/NewsList.tsx
import { Stack, Box, CircularProgress, Alert } from '@mui/material';
import { NewsCard } from './NewsCard';
import { NewsArticle } from '@/types/news.types';

interface NewsListProps {
  news: NewsArticle[];
  loading?: boolean;
  error?: string | null;
  limit?: number;
  variant?: 'default' | 'modal';
  onReadMore?: (newsItem: NewsArticle, imageUrl: string) => void;
}

export const NewsList = ({ 
  news, 
  loading, 
  error, 
  limit, 
  variant = 'default',
  onReadMore 
}: NewsListProps) => {
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Alert severity="error" variant="outlined" sx={{ py: 2, textAlign: 'center' }}>
        {error}
      </Alert>
    );
  }

  const displayNews = limit ? news.slice(0, limit) : news;

  if (displayNews.length === 0) {
    return (
      <Box sx={{ textAlign: 'center', py: 6 }}>
        <Alert severity="info">No hay noticias disponibles</Alert>
      </Box>
    );
  }

  return (
    <Stack spacing={variant === 'modal' ? 3 : { xs: 0.5, md: 1, lg: 2 }}>
      {displayNews.map((newsItem, index) => (
        <NewsCard
        // newsItem.id ||
          key={ index}
          newsItem={newsItem}
          variant={variant}
          onReadMore={(imageUrl) => onReadMore?.(newsItem, imageUrl)}
        />
      ))}
    </Stack>
  );
};